// ctx-strict-property-migration
import type {Switch} from '@fluentui/web-components';
import 'src/components/fluentComponentRegistration';
import {LinearProgress} from "@material/mwc-linear-progress";
import {Icon} from "@material/mwc-icon";
import {css, html, LitElement} from "lit";
import {customElement, property, query} from "lit/decorators.js";
import {updateGroupUser} from 'src/services';
import {Task} from '@lit/task';
import {raiseAsyncPromiseEvent} from 'src/modules/helpers/message-helper';
import {fallbackRenderer} from 'src/modules/helpers/lit-helpers';

LinearProgress;
Icon

@customElement("group-user-item")
export class GroupUserItem extends LitElement {
  static styles = css`
    :host([hidden]) {
      display: none
    }

    .grid-container {
      display: grid;
      grid-template-columns: 8fr 2fr 2fr;
      grid-column-gap: 1em;
      gap: 7px;
      align-items: center;
    }

    .horizontal-center {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    @keyframes rotating {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .rotating {
      animation: rotating 2s linear infinite;
      width: min-content;
    }

    mwc-linear-progress {
      zoom: 0.5;
    }

    mwc-icon-button {
      position: relative;
      top: -11px;
      right: 10px;
    }
  `;

  @property({type: Number}) groupUserKey!: number
  //todo change to drill-down
  @property({type: Boolean}) drilldown: boolean = false;
  @property({type: Boolean}) readonly!: boolean

  @property() username!: string

  @query("fluent-switch") private _switch!: Switch;

  _UpdatingDrillDownTask = new Task(this, {
    task: async () => {
      await raiseAsyncPromiseEvent(this, updateGroupUser(this.groupUserKey, this._switch.checked), {
        progress: "Updating User",
        success: "User Updated",
        failed: "Update Failed"
      })
      this.drilldown = this._switch.checked;
      return this.drilldown;
    },
  });

  requestToggleDrillDownHandler = async (event: Event) => {
    await this._UpdatingDrillDownTask.run();
  }

  render = () => html`
    <div class="grid-container">
      <slot name="front-slot">${this.username}</slot>
      ${this.readonly ? this.renderDrillDownViewer() : this.renderDrillDownEditor()}
      <slot name="end-slot"></slot>
    </div>
  `;

  renderDrillDownViewer = () => this.drilldown
    ? html`<mwc-icon slot="checked-message">lock_open</mwc-icon>`
    : html`<div></div>`

  renderDrillDownEditor = () => html`
    <div class="horizontal-center">
      ${this._UpdatingDrillDownTask.render(fallbackRenderer({
        pending: () => html`<mwc-icon class="rotating">refresh</mwc-icon>`,
        default: () => html`<div></div>`,
      }))}
      <fluent-switch @change=${this.requestToggleDrillDownHandler} ?checked=${this.drilldown}>
        <mwc-icon slot="checked-message">lock_open</mwc-icon>
      </fluent-switch>
    </div>
  `;
}